import { Components, Theme } from '@mui/material';

export const MuiInputLabel: Components<Theme>['MuiInputLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.grey[600],
    }),
    sizeSmall: {
      top: '-3px',
    },
    shrink: {
      top: '0px',
    },
  },
};
